import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import FormField from 'screens/Companies/components/FormField';

const AddressLineTwoField = () => {
  return (
    <FormField label="Address Line 2" htmlFor="line2">
      <FormikInput id="line2" name="address.line2" />
    </FormField>
  );
};

export default AddressLineTwoField;
